<template>
	<fieldset
		class="checkbox"
	>
		<span
			class="checkbox-area"
			:class="{
				'checkbox-area--block': block
			}"
		>
			<input
				type="checkbox"
				:id="uniqueId"
				:name="name"
				:required="required"
				:value="value"
				@change="onChange"
				:checked="checked"
				:disabled="disabled"
				autocomplete="off"
			>
			<label
				:for="uniqueId"
			>
        <slot>
					<span v-sanitize="label"/>
				</slot>
      </label>
		</span>
	</fieldset>
</template>

<script>
export default {
  model: {
		prop: 'checked',
		event: 'input'
	},
	props: {
		name: String,
		label: String,
		required: Boolean,
    value: Number | String,
    checked: Boolean,
		vertical: Boolean,
		disabled: Boolean,
		block: Boolean
	},
	data() {
		return {
			uniqueId: `${this.name}-${(Date.now().toString(36) + Math.random().toString(36).substring(2, 7))}`,
		}
	},
	methods: {
		onChange(e) {
			this.$emit('input', e.target.checked);
		}
	}
}
</script>

<style>

</style>
